var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1920 240",
    width: 1920,
    height: 240,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 240,
    fill: "#14141F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 56L64 79.7C128 103.3 256 150.7 384 147.3C512 144 640 90 768 88.5C896 87 1024 138 1152 158.5C1280 179 1408 169 1536 143.7C1664 118.3 1792 77.7 1856 57.3L1920 37",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    stroke: "#FFDE00",
    strokeWidth: 40
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWave);
export default __webpack_public_path__ + "static/media/yellow-wave.ca272bb9f670ec6cd343a70a0d38305e.svg";
export { ForwardRef as ReactComponent };